import React from 'react';
import styles from './ColItem.module.scss';

const ColItem = ({ text = '', label = '' }) => {
  return (
    <div className={styles.root}>
      <div className={styles.label}>{label}</div>
      <div className={styles.text}>{text}</div>
    </div>
  );
};

export default ColItem;
